import { combine, Store } from 'effector';
import { EntityWithName } from 'shared/api';
import { MultiSelectItem } from 'shared/ui';

export const combineCashiersMultiselectData = (
	$freeCashiers: Store<EntityWithName[]>,
	$currentCashier: Store<EntityWithName[]>,
): Store<MultiSelectItem[]> =>
	combine(
		{
			freeCashiers: $freeCashiers,
			currentCashier: $currentCashier,
		},
		({ freeCashiers, currentCashier }) => [
			...freeCashiers.map((cashier) => ({ value: `${cashier.id}`, label: cashier.name })),
			...currentCashier.map((cashier) => ({ value: `${cashier.id}`, label: cashier.name })),
		],
	);
